import SurveysForm from './SurveysForm.vue'
export {SurveysForm}
export default SurveysForm